/**
 * SSO Authentication Service
 * Handles SSO token verification
 *
 * Refactored from: 3in1cms/bajajfinserv-web/ui.solid/src/lib/connectionManager/sso.ts
 * Logic preserved AS-IS, only imports updated for monorepo structure
 */

import { COMMON_SSO_ACCESS_TOKEN, SSO_CHANNEL_ID } from "../constants/sso";
import { request } from "../core/request";
import { CONNECTION_MANAGER_ENV, OPERATION_IDS, REST_CONNECTION_FROM } from "./constants";
import { VerifySSOTokenResponse } from "../types/ssoTypes";

/**
 * Verify SSO token for authentication
 * @param mobileNo - User's mobile number
 * @param p_token - Optional perpetual token (if not provided, reads from localStorage)
 * @returns Promise with token verification response
 */
export const verifySSOToken = async (
  mobileNo: string,
  p_token?: string
): Promise<VerifySSOTokenResponse> => {
  try {
    const response = (await request({
      operationId: OPERATION_IDS.tokenVerifySso,
      requestData: {
        username: mobileNo,
        token: p_token || localStorage.getItem(COMMON_SSO_ACCESS_TOKEN),
        channelId: CONNECTION_MANAGER_ENV === "UAT" ? SSO_CHANNEL_ID.UAT : SSO_CHANNEL_ID.PROD,
      },
      connectionFrom: REST_CONNECTION_FROM,
      additionalHeaders: {
        additionalinfo1: 1,
      },
    })) as VerifySSOTokenResponse;

    if (response.statuscode !== 200) {
      throw new Error(JSON.stringify(response));
    }

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
